webpackJsonp([162898551421021],{

/***/ 3043:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/blankCanvas.5eadd26a.png";

/***/ }),

/***/ 1649:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _blankCanvas = __webpack_require__(3043);
	
	var _blankCanvas2 = _interopRequireDefault(_blankCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "404 - Page Not Found"
	      ),
	      _react2.default.createElement("meta", { name: "description", content: "Page not found" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.container },
	      _react2.default.createElement(
	        "div",
	        { className: classes.inner },
	        _react2.default.createElement("img", {
	          className: classes.image,
	          src: _blankCanvas2.default,
	          alt: "Woman starting at blank canvas"
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: classes.content },
	          _react2.default.createElement(
	            "h1",
	            { className: classes.heading },
	            "Page not found"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: classes.body },
	            "We couldn't find the page you were looking for. Let's get you back home."
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/", className: classes.link },
	            "Go back home"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    container: {
	      margin: "100px auto 180px auto",
	      display: "flex",
	      justifyContent: "center",
	      alignContent: "center",
	      flexDirection: "column",
	      maxWidth: "400px",
	      textAlign: "center"
	    },
	    inner: {
	      display: "flex",
	      flexDirection: "column",
	      alignItems: "center"
	    },
	    image: {
	      maxWidth: "400px",
	      maxHeight: "300px"
	    },
	    heading: {
	      color: "#5A5B5C",
	      fontSize: "44px",
	      fontWeight: "600",
	      marginBottom: "10px"
	    },
	    body: {
	      fontSize: "18px",
	      fontWeight: "500",
	      marginBottom: "24px"
	    },
	    content: {
	      color: "#5A5B5C",
	      display: "flex",
	      flexDirection: "column",
	      lineHeight: "1.3",
	      alignItems: "center"
	    },
	    subHeading: {
	      fontSize: "18px",
	      fontWeight: "700",
	      marginBottom: "20px"
	    },
	    link: {
	      color: "#FFF",
	      textAlign: "center",
	      fontWeight: "700",
	      textDecoration: "none",
	      fontSize: "18px",
	      // border: "2px solid #2E7FC2",
	      backgroundColor: "#F15953",
	      borderRadius: "6px",
	      padding: "14px 60px"
	    }
	  };
	})(NotFoundPage);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-40aaa1dbb28ede0c6167.js